import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function ACTFreeTrialRedirect() {
    const navigate = useNavigate();
    const { token } = useParams();
    
    useEffect(() => {
        navigate(`/login?token=${token}`);
    }, [navigate, token]);

    return null;
}

export default ACTFreeTrialRedirect;